// src/modules/lab/index.js
import React, { Component } from 'react';
import '../../styles/lab.css';
import { API_ENDPOINTS, postRequest } from '../../config/apiConfig';

/* ── Icons ──────────────────────────────────────────────────── */
const ICONS = {
  heartbeat: 'M22 12h-4l-3 9L9 3l-3 9H2',
  qr:        'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h3v3h-3zM20 14v3M17 20h3M20 20v1',
  flask:     'M9 3h6M9 3v6l-4.5 9A2 2 0 006.5 21h11a2 2 0 001.996-2.1L15 9V3',
  check:     'M20 6L9 17l-5-5',
  bell:      'M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0',
  menu:      'M3 12h18M3 6h18M3 18h18',
  logout:    'M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9',
  info:      'M12 22a10 10 0 100-20 10 10 0 000 20zM12 8h.01M11 12h1v4h1',
  alert:     'M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z',
  scan:      'M4 7V4h3M17 4h3v3M20 17v3h-3M7 20H4v-3M7 12h10M12 7v10',
  save:      'M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2zM17 21v-8H7v8M7 3v5h8',
  user:      'M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z',
  refresh:   'M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15',
  eye:       'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 100 6 3 3 0 000-6z',
  spinner:   'M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83',
};

class Ico extends Component {
  render() {
    const { name, size = 18, color = 'currentColor', className = '' } = this.props;
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
        stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        className={className} style={{ flexShrink: 0 }}>
        <path d={ICONS[name] || ICONS.info} />
      </svg>
    );
  }
}

/* ── Demo data ──────────────────────────────────────────────── */
const SCANNED_PATIENT = {
  name: 'Raj Sharma', apptId: 'APT-2401', age: 35,
  doctor: 'Dr. Meena Kapoor', dept: 'Cardiology',
};

const SCANNED_TESTS = [
  { id:'T1', name:'Complete Blood Count (CBC)',  dept:'Haematology',  priority:'normal', status:'pending'    },
  { id:'T2', name:'Random Blood Sugar (RBS)',    dept:'Biochemistry', priority:'urgent', status:'collected'  },
  { id:'T3', name:'Urine Routine & Microscopy', dept:'Microbiology', priority:'normal', status:'pending'    },
];

const QUEUE_DATA = [
  { id:'APT-2401', patient:'Raj Sharma',   age:35, test:'CBC',          dept:'Haematology',  time:'10:00 AM', status:'inprogress', priority:'normal' },
  { id:'APT-2402', patient:'Priya Verma',  age:28, test:'Blood Sugar',  dept:'Biochemistry', time:'10:30 AM', status:'pending',    priority:'urgent' },
  { id:'APT-2403', patient:'Anil Kumar',   age:52, test:'Urine Routine',dept:'Microbiology', time:'11:00 AM', status:'pending',    priority:'normal' },
  { id:'APT-2404', patient:'Sunita Rao',   age:44, test:'LFT',          dept:'Biochemistry', time:'11:30 AM', status:'collected',  priority:'normal' },
  { id:'APT-2405', patient:'Vikram Joshi', age:39, test:'CBC',          dept:'Haematology',  time:'12:00 PM', status:'pending',    priority:'normal' },
];

const COMPLETED_DATA = [
  { id:'APT-2398', patient:'Geeta Mishra', age:61, test:'X-Ray Chest', dept:'Radiology',    date:'31 Mar', status:'completed' },
  { id:'APT-2399', patient:'Deepak Nair',  age:47, test:'ECG',         dept:'Cardiology',   date:'31 Mar', status:'completed' },
  { id:'APT-2400', patient:'Kavita Iyer',  age:33, test:'Blood Sugar', dept:'Biochemistry', date:'31 Mar', status:'completed' },
];

/* ── Badge ─────────────────────────────────────────────────── */
function LBadge({ status, priority }) {
  const v = status || priority || 'normal';
  const cls = `lb-badge lb-badge-${v}`;
  const L = { pending:'Pending', collected:'Collected', inprogress:'In Progress', completed:'Completed', urgent:'Urgent', normal:'Normal' };
  return <span className={cls}>{L[v] || v}</span>;
}

/* ════════════════════════════════════════════════════════════
   SIDEBAR
════════════════════════════════════════════════════════════ */
class Sidebar extends Component {
  render() {
    const { activePage, onNav, isOpen, onClose, onLogout } = this.props;
    const NAV = [
      { id:'scan',      label:'Scan QR',    icon:'qr'    },
      { id:'queue',     label:'Test Queue', icon:'bell'  },
      { id:'completed', label:'Completed',  icon:'check' },
    ];
    return (
      <>
        <div className={`lb-overlay${isOpen?' open':''}`} onClick={onClose} />
        <aside className={`lb-sidebar${isOpen?' open':''}`}>
          <div className="lb-sidebar-logo">
            <div className="lb-sidebar-logo-icon">
              <Ico name="heartbeat" size={18} color="#fff" />
            </div>
            <div>
              <div className="lb-logo-name">DG Doctor</div>
              <div className="lb-logo-sub">Hospital System</div>
            </div>
          </div>
          <div className="lb-user-badge">
            <div className="lb-user-avatar">LB</div>
            <div>
              <div className="lb-user-name">Lab Technician</div>
              <div className="lb-user-role">Lab Staff</div>
            </div>
          </div>
          <nav className="lb-nav">
            <span className="lb-nav-label">Menu</span>
            {NAV.map(item => (
              <button key={item.id}
                className={`lb-nav-btn${activePage===item.id?' active':''}`}
                onClick={() => { onNav(item.id); onClose(); }}>
                <Ico name={item.icon} size={16} color={activePage===item.id?'var(--lb-brand)':'var(--lb-text-3)'} />
                {item.label}
                {activePage===item.id && <div className="lb-nav-dot" />}
              </button>
            ))}
          </nav>
          <button className="lb-signout" onClick={onLogout}>
            <Ico name="logout" size={15} /> Sign out
          </button>
        </aside>
      </>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   HEADER
════════════════════════════════════════════════════════════ */
class Header extends Component {
  render() {
    const { title, subtitle, onMenuClick } = this.props;
    return (
      <header className="lb-header">
        <button className="lb-header-menu" onClick={onMenuClick}>
          <Ico name="menu" size={20} />
        </button>
        <div>
          <div className="lb-header-title">{title}</div>
          {subtitle && <div className="lb-header-sub">{subtitle}</div>}
        </div>
        <div className="lb-header-right">
          <div className="lb-header-bell">
            <Ico name="bell" size={17} color="var(--lb-text-2)" />
            <div className="lb-bell-dot" />
          </div>
          <div className="lb-header-avatar">AU</div>
        </div>
      </header>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   SCAN PAGE — exact match to screenshot
════════════════════════════════════════════════════════════ */
/* ── Load jsQR ──────────────────────────────────────────────── */
function loadJsQR() {
  return new Promise(resolve => {
    if (window.jsQR) { resolve(); return; }
    const urls = [
      'https://unpkg.com/jsqr@1.4.0/dist/jsQR.js',
      'https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.min.js',
    ];
    let idx = 0;
    const tryNext = () => {
      if (idx >= urls.length) { resolve(); return; }
      const s = document.createElement('script');
      s.src = urls[idx++]; s.onload = resolve; s.onerror = tryNext;
      document.head.appendChild(s);
    };
    tryNext();
  });
}

class ScanPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode:        'scan',
      apptId:      null,
      uploadLoading: false,
      uploadError:   null,
      manualId:      '',
      manualMode:    false,
      patient:     null,
      labTests:    [],       // [ { LABTID, name } ] from data[0][0].Lab_test_details split
      labReports:  [],       // [ { LAB_REPORTID, LabTestName, Report_Status, Path, Type } ] from labReport[0]
      testFiles:   {},       // { [LABTID]: File }
      testStatus:  {},       // { [LABTID]: status }
      saving:      false,
      saved:       false,
      saveError:   null,
      errorMsg:    null,
      inlineCamOn:  false,
      inlineCamErr: '',
    };
    this.fileInputRef  = React.createRef();
    this.cameraInputRef = React.createRef();
    this.videoRef      = React.createRef();
    this.canvasRef     = React.createRef();
    this.testFileRefs  = {};
    this.streamRef     = null;
    this.scanLoop      = null;
  }

  componentDidMount()    { this.startInlineCamera(); }
  componentWillUnmount() { this.stopInlineCamera(); }

  async startInlineCamera() {
    await loadJsQR();
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: { ideal: 'environment' }, width: { ideal: 1280 }, height: { ideal: 720 } }
      });
      this.streamRef = stream;
      this.setState({ inlineCamOn: true, inlineCamErr: '' });
      setTimeout(() => {
        if (this.videoRef.current) {
          this.videoRef.current.srcObject = stream;
          this.videoRef.current.play();
          this.videoRef.current.onloadedmetadata = () => this.startScanLoop();
        }
      }, 300);
    } catch(err) {
      this.setState({ inlineCamOn: false, inlineCamErr: 'Camera unavailable (needs HTTPS on mobile network)' });
    }
  }

  stopInlineCamera() {
    if (this.scanLoop) { cancelAnimationFrame(this.scanLoop); this.scanLoop = null; }
    if (this.streamRef) { this.streamRef.getTracks().forEach(t => t.stop()); this.streamRef = null; }
    this.setState({ inlineCamOn: false });
  }

  startScanLoop() {
    const tick = () => {
      const v = this.videoRef.current, c = this.canvasRef.current;
      if (!v || !c) return;
      c.width = v.videoWidth; c.height = v.videoHeight;
      const ctx = c.getContext('2d');
      ctx.drawImage(v, 0, 0);
      const d = ctx.getImageData(0, 0, c.width, c.height);
      const code = window.jsQR(d.data, d.width, d.height, { inversionAttempts: 'dontInvert' });
      if (code) { this.stopInlineCamera(); this.handleQRData(code.data); return; }
      this.scanLoop = requestAnimationFrame(tick);
    };
    this.scanLoop = requestAnimationFrame(tick);
  }

  /* ── Decode QR from uploaded image ──────────────────────── */
  async decodeFromFile(file) {
    if (!file) return;
    await loadJsQR();
    this.setState({ uploadLoading: true, uploadError: null });
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        // Downscale large mobile photos — jsQR works best at 600-1000px
        const MAX = 1024;
        let w = img.width, h = img.height;
        if (w > MAX || h > MAX) {
          if (w > h) { h = Math.round(h * MAX / w); w = MAX; }
          else       { w = Math.round(w * MAX / h); h = MAX; }
        }
        const c = document.createElement('canvas');
        c.width = w; c.height = h;
        const ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        const d = ctx.getImageData(0, 0, w, h);
        // Try normal first, then invert (some QR codes on dark backgrounds)
        let code = window.jsQR(d.data, d.width, d.height, { inversionAttempts: 'dontInvert' });
        if (!code) code = window.jsQR(d.data, d.width, d.height, { inversionAttempts: 'invertFirst' });
        this.setState({ uploadLoading: false });
        if (code) { this.handleQRData(code.data); }
        else { this.setState({ uploadError: 'Could not read QR. Hold camera steady, ensure QR fills the frame, and try again.' }); }
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  /* ── Parse QR data → AppointmentID ──────────────────────── */
  handleQRData(raw) {
    let apptId = null;
    try { const url = new URL(raw); apptId = url.searchParams.get('id') || url.searchParams.get('ID'); } catch(_) {}
    if (!apptId) { try { const p = JSON.parse(raw); apptId = p.AppointmentID || p.appointmentId; } catch(_) {} }
    if (!apptId) { const m = raw.match(/ID:(\d+)/); if (m) apptId = m[1]; }
    if (!apptId && /^\d+$/.test(raw.trim())) apptId = raw.trim();
    if (apptId) { this.fetchLabData(String(apptId)); }
    else { this.setState({ uploadError: 'Invalid QR — no Appointment ID found.' }); }
  }

  /* ── Fetch lab tests for appointment ────────────────────── */
  async fetchLabData(apptId) {
    this.setState({ mode: 'loading', apptId, uploadError: null });
    try {
      const res  = await postRequest(API_ENDPOINTS.GET_LAB_RESULTS, { AppointmentID: apptId });
      const data = await res.json();
      console.log('Lab results response:', data);

      // ── Parse patient + lab test details from data[0][0] ──
      let row = null;
      if (data.status && Array.isArray(data.data?.[0])) row = data.data[0][0] || null;
      else if (Array.isArray(data.data)) row = data.data[0] || null;

      // Split Lab_test_details text into individual test names
      const labText = row?.Lab_test_details || row?.LabTests || '';
      const testNames = labText
        ? labText.split(/\\n|\n|\r/).map(l => l.replace(/^[0-9]+[.)\s]*/, '').trim()).filter(Boolean)
        : [];

      // Build labTests array with LABTID
      const LABTID = row?.LABTID || 1;
      const labTests = testNames.map((name, i) => ({ id: `${LABTID}_${i}`, name }));

      // ── Parse labReport array from data.labReport[0] ──
      let labReports = [];
      if (Array.isArray(data.labReport?.[0])) {
        labReports = data.labReport[0];
      } else if (Array.isArray(data.labReport)) {
        labReports = data.labReport;
      }
      console.log('Lab reports:', labReports);

      // Init status from existing reports
      const testStatus = {};
      labTests.forEach((t, i) => {
        // Match by index or test name
        const report = labReports[i] || labReports.find(r =>
          (r.LabTestName||'').toLowerCase() === t.name.toLowerCase()
        );
        testStatus[i] = report?.Report_Status || 'pending';
      });

      this.setState({
        mode: 'result', patient: row,
        labTests, labReports, testStatus, testFiles: {}, saved: false,
      });
    } catch (err) {
      this.setState({ mode: 'error', errorMsg: err.message });
    }
  }

  /* ── Handle result file upload per test ─────────────────── */
  handleTestFile(idx, file) {
    if (!file) return;
    this.setState(s => ({
      testFiles:  { ...s.testFiles,  [idx]: file },
      testStatus: { ...s.testStatus, [idx]: 'completed' },
    }));
  }

  /* ── View existing file ──────────────────────────────────── */
  viewFile(path) {
    if (!path) return;
    let url = path;
    if (!path.startsWith('http')) {
      // Build backend URL using same host but port 5000
      const host = window.location.hostname;
      url = `https://${host}/backend/${path}`;
    }
    console.log('Opening file:', url);
    window.open(url, '_blank');
  }

  updateStatus(idx, val) {
    this.setState(s => ({ testStatus: { ...s.testStatus, [idx]: val } }));
  }

  /* ── Save all results ────────────────────────────────────── */
  async saveResults() {
    const { apptId, labTests, labReports, testStatus, testFiles } = this.state;
    this.setState({ saving: true, saveError: null });
    try {
      // Get logged-in lab user PersonID
      const raw      = localStorage.getItem('dg_user');
      const user     = raw ? JSON.parse(raw) : null;
      const personId = user?.personId || '';

      // Get LABTID from first lab test row
      const LABTID   = this.state.patient?.LABTID || '';

      const form = new FormData();
      form.append('AppointmentID', apptId);
      form.append('LABTID',        LABTID);
      form.append('PersonID',      personId);

      // Backend expects tests[i][field] array format
      labTests.forEach((test, i) => {
        const report = labReports[i] || labReports.find(r =>
          (r.LabTestName||'').toLowerCase() === test.name.toLowerCase()
        );
        form.append('tests[' + i + '][name]',        test.name);
        form.append('tests[' + i + '][status]',       testStatus[i] || 'pending');
        form.append('tests[' + i + '][LAB_REPORTID]', report?.LAB_REPORTID || '');
        form.append('tests[' + i + '][LABTID]',       report?.LABTID || LABTID);
        if (testFiles[i]) {
          const ext      = testFiles[i].name.split('.').pop();
          const cleanName = (test.name.replace(/[^a-zA-Z0-9]/g,'_') + '_result.' + ext);
          const renamed   = new File([testFiles[i]], cleanName, { type: testFiles[i].type });
          form.append('tests[' + i + '][file]', renamed, cleanName);
        }
      });

      const uploadUrl = API_ENDPOINTS.UPLOAD_LAB_RESULTS;
      console.log('POST to:', uploadUrl);
      console.log('FormData entries:');
      for (let [k,v] of form.entries()) console.log(' ', k, '=', v instanceof File ? v.name : v);

      const token = localStorage.getItem('dg_token') || '';
      const res = await fetch(uploadUrl, {
        method: 'POST',
        headers: token ? { 'Authorization': 'Bearer ' + token } : {},
        body: form,
      });
      console.log('Response status:', res.status, res.url);
      const result = await res.json();
      console.log('Save response:', result);
      this.setState({ saving: false, saved: true });
    } catch (err) {
      console.error('Save error:', err);
      this.setState({ saving: false, saveError: err.message });
    }
  }

  reset() {
    if (this.fileInputRef.current) this.fileInputRef.current.value = '';
    this.setState({ mode:'scan', apptId:null, patient:null, labTests:[], labReports:[], testFiles:{}, testStatus:{}, saved:false, saveError:null, uploadError:null, manualId:'', manualMode:false, errorMsg:null });
  }

  render() {
    const { mode, patient, labTests, labReports, testStatus, testFiles, saving, saved, saveError, uploadLoading, uploadError, manualId, manualMode, apptId, errorMsg } = this.state;

    const patientName = patient ? `${patient.PatientFirstName||patient.patfname||''} ${patient.PatientLastName||patient.patlname||''}`.trim() || `Appt #${apptId}` : `Appt #${apptId}`;
    const doctorName  = patient ? `Dr. ${patient.DoctorFirstName||''} ${patient.DoctorLastName||''}`.trim() : '—';
    const dept        = patient?.DepartmentName || '—';
    const initials    = patientName.split(' ').map(w=>w[0]||'').slice(0,2).join('').toUpperCase() || 'PT';

    return (
      <div>
        <div className="lb-page-header lb-fade-up">
          <h1 className="lb-page-title">Lab Panel — Scan QR</h1>
          <p className="lb-page-sub">Scan patient QR to view and upload lab test results</p>
        </div>

        <div className="lb-card lb-fade-up-1">
          <div className="lb-card-body" style={{ padding: mode === 'scan' ? 0 : 20 }}>

            {/* ── SCAN MODE ── */}
            {mode === 'scan' && (
              <div style={{ padding: 16 }}>

                {/* Live camera preview */}
                <div style={{ position:'relative', borderRadius:16, overflow:'hidden', background:'#000', marginBottom:14, width:280, height:280, margin:'0 auto 14px' }}>
                  <video ref={this.videoRef} muted playsInline autoPlay
                    style={{ width:'100%', height:'100%', objectFit:'cover', display:this.state.inlineCamOn?'block':'none' }} />
                  <canvas ref={this.canvasRef} style={{ display:'none' }} />

                  {/* Corner overlay */}
                  {this.state.inlineCamOn && (
                    <div style={{ position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center', pointerEvents:'none' }}>
                      <div style={{ width:180, height:180, position:'relative' }}>
                        {[[0,0,'top','left'],[0,1,'top','right'],[1,0,'bottom','left'],[1,1,'bottom','right']].map(([tb,lr,tv,lv],i) => (
                          <div key={i} style={{ position:'absolute', [tv]:0, [lv]:0, width:32, height:32,
                            borderTop: tb===0?'3px solid #fff':'none', borderBottom: tb===1?'3px solid #fff':'none',
                            borderLeft: lr===0?'3px solid #fff':'none', borderRight: lr===1?'3px solid #fff':'none', borderRadius:3 }} />
                        ))}
                        <div style={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)', color:'rgba(255,255,255,.7)', fontSize:11, textAlign:'center', whiteSpace:'nowrap' }}>
                          Point camera at QR
                        </div>
                      </div>
                    </div>
                  )}

                  {/* No camera */}
                  {!this.state.inlineCamOn && (
                    <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:10, color:'#fff' }}>
                      <Ico name="scan" size={36} color="rgba(255,255,255,.4)" />
                      <div style={{ fontSize:12, color:'rgba(255,255,255,.6)', textAlign:'center', padding:'0 20px' }}>
                        {this.state.inlineCamErr || 'Starting camera…'}
                      </div>
                      {this.state.inlineCamErr && (
                        <button onClick={() => this.startInlineCamera()}
                          style={{ padding:'7px 16px', borderRadius:20, border:'1.5px solid rgba(255,255,255,.4)', background:'transparent', color:'#fff', fontSize:12, cursor:'pointer', fontFamily:'inherit' }}>
                          Try Again
                        </button>
                      )}
                    </div>
                  )}
                </div>

                {uploadError && (
                  <div style={{ background:'#FFF0EB', border:'1px solid #fcd9c4', borderRadius:10, padding:'10px 14px', marginBottom:12, fontSize:13, color:'#FF6B35', display:'flex', gap:8, alignItems:'center' }}>
                    <Ico name="alert" size={14} color="#FF6B35" /> {uploadError}
                  </div>
                )}

                {/* Hidden inputs */}
                <input ref={this.fileInputRef} type="file" accept="image/*" style={{ display:'none' }}
                  onChange={e => { if (e.target.files[0]) this.decodeFromFile(e.target.files[0]); }} />
                <input ref={this.cameraInputRef} type="file" accept="image/*" capture="environment" style={{ display:'none' }}
                  onChange={e => { if (e.target.files[0]) this.decodeFromFile(e.target.files[0]); }} />

                {/* Buttons */}
                <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:10, marginBottom:10 }}>
                  <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
                    <button className="lb-btn-scan" style={{ background:'var(--lb-brand)', justifyContent:'center', flexDirection:'column', gap:4, padding:'12px 20px', width:130 }}
                      disabled={uploadLoading}
                      onClick={() => { this.fileInputRef.current.value=''; this.fileInputRef.current.click(); }}>
                      <Ico name="scan" size={18} color="#fff" />
                      <span style={{ fontSize:12 }}>{uploadLoading ? 'Reading…' : 'Upload Image'}</span>
                    </button>
                    <button className="lb-btn-scan" style={{ background:'#059669', justifyContent:'center', flexDirection:'column', gap:4, padding:'12px 20px', width:130 }}
                      disabled={uploadLoading}
                      onClick={() => { this.cameraInputRef.current.value=''; this.cameraInputRef.current.click(); }}>
                      <Ico name="scan" size={18} color="#fff" />
                      <span style={{ fontSize:12 }}>Take Photo</span>
                    </button>
                  </div>

                  <button style={{ width:280, border:'1.5px solid var(--lb-border)', borderRadius:10, padding:'10px 16px', cursor:'pointer', display:'flex', alignItems:'center', gap:8, justifyContent:'center', background:'#fff', fontSize:13, fontWeight:600, color:'var(--lb-text-2)' }}
                    onClick={() => this.setState({ manualMode: !manualMode })}>
                    ⌨️ Enter Appointment ID
                  </button>
                </div>

                {manualMode && (
                  <div style={{ display:'flex', gap:8, marginTop:8 }}>
                    <input type="number" placeholder="e.g. 10" value={manualId}
                      onChange={e => this.setState({ manualId: e.target.value })}
                      onKeyDown={e => e.key === 'Enter' && manualId && this.fetchLabData(manualId)}
                      style={{ flex:1, height:44, borderRadius:10, border:'1.5px solid var(--lb-border)', padding:'0 14px', fontSize:15, fontWeight:700, fontFamily:'inherit', outline:'none', textAlign:'center' }}
                      onFocus={e=>e.target.style.borderColor='var(--lb-brand)'} onBlur={e=>e.target.style.borderColor='var(--lb-border)'} autoFocus />
                    <button className="lb-btn-scan" style={{ width:'auto', padding:'0 20px' }}
                      onClick={() => manualId && this.fetchLabData(manualId)} disabled={!manualId}>
                      Go →
                    </button>
                  </div>
                )}

                <p className="lb-scan-note" style={{ marginTop:12 }}>🔒 Lab role — medicine prescriptions are hidden</p>
              </div>
            )}

            {/* ── LOADING ── */}
            {mode === 'loading' && (
              <div style={{ textAlign:'center', padding:'48px 20px' }}>
                <Ico name="spinner" size={36} color="var(--lb-brand)" className="lb-spinner" />
                <p style={{ marginTop:14, color:'var(--lb-text-2)', fontWeight:600 }}>Loading lab tests for Appt #{apptId}…</p>
              </div>
            )}

            {/* ── ERROR ── */}
            {mode === 'error' && (
              <div style={{ textAlign:'center', padding:'40px 20px' }}>
                <Ico name="alert" size={32} color="var(--lb-warn)" />
                <p style={{ marginTop:12, color:'var(--lb-text-2)', fontSize:14 }}>{errorMsg}</p>
                <button className="lb-btn-ghost" style={{ marginTop:16 }} onClick={() => this.reset()}>← Try Again</button>
              </div>
            )}

            {/* ── RESULT ── */}
            {mode === 'result' && (
              <div>
                {/* Patient banner */}
                <div className="lb-patient-banner">
                  <div className="lb-patient-avatar">{initials}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:700, fontSize:15 }}>{patientName}</div>
                    <div style={{ fontSize:12, color:'var(--lb-text-2)' }}>Appt #{apptId} · {doctorName} · {dept}</div>
                  </div>
                  <button className="lb-btn-ghost" onClick={() => this.reset()}>
                    <Ico name="refresh" size={14} /> New Scan
                  </button>
                </div>

                <div className="lb-role-notice">
                  <Ico name="info" size={14} color="var(--lb-purple)" />
                  Lab Panel — <strong style={{ marginLeft:3 }}>Test orders only.</strong> Upload result files against each test.
                </div>

                {saved && (
                  <div className="lb-alert lb-alert-success">
                    <Ico name="check" size={15} color="#059669" /> Results saved successfully!
                  </div>
                )}
                {saveError && (
                  <div className="lb-alert" style={{ background:'#FFF0EB', border:'1px solid #fcd9c4', color:'#FF6B35' }}>
                    <Ico name="alert" size={15} color="#FF6B35" /> Save failed: {saveError}
                  </div>
                )}

                {labTests.length === 0 ? (
                  <div style={{ textAlign:'center', padding:'40px 20px' }}>
                    <div style={{ width:64, height:64, borderRadius:18, background:'#F1F5F9', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px' }}>
                      <Ico name="flask" size={28} color="var(--lb-border)" />
                    </div>
                    <div style={{ fontWeight:700, fontSize:16, color:'var(--lb-text-2)', marginBottom:6 }}>No Record Found</div>
                    <p style={{ fontSize:13, color:'var(--lb-text-3)', marginBottom:16, lineHeight:1.6 }}>
                      No lab tests have been ordered for this appointment.<br/>
                      The doctor may not have written a lab prescription yet.
                    </p>
                    <button className="lb-btn-ghost" onClick={() => this.reset()}>
                      <Ico name="refresh" size={14} /> Scan Another QR
                    </button>
                  </div>
                ) : (
                  <>
                    <div style={{ fontSize:11, fontWeight:700, color:'var(--lb-text-3)', textTransform:'uppercase', letterSpacing:'.5px', marginBottom:12, paddingBottom:8, borderBottom:'1px solid var(--lb-border)' }}>
                      {labTests.length} Test Order{labTests.length !== 1 ? 's' : ''}
                    </div>

                    {labTests.map((test, i) => {
                      const testName = test.name;
                      const status   = testStatus[i] || 'pending';
                      const file     = testFiles[i];
                      // Find existing report for this test
                      const report   = labReports[i] || labReports.find(r =>
                        (r.LabTestName||'').toLowerCase() === testName.toLowerCase()
                      );
                      const hasFile  = report?.Path && report.Path !== null;
                      if (!this.testFileRefs[i]) this.testFileRefs[i] = React.createRef();
                      return (
                        <div key={i} style={{
                          border: '1.5px solid var(--lb-border)', borderRadius: 12,
                          marginBottom: 12, overflow: 'hidden',
                          boxShadow: '0 1px 4px rgba(0,0,0,.04)',
                        }}>
                          {/* Test header */}
                          <div style={{
                            display:'flex', alignItems:'center', gap:12,
                            padding:'12px 16px',
                            background: status === 'completed' ? '#F0FDF4' : 'var(--lb-purple-light, #F5F3FF)',
                            borderBottom: '1px solid var(--lb-border)',
                          }}>
                            <div style={{ width:36, height:36, borderRadius:10, background:'var(--lb-purple-light,#F0EDFE)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                              <Ico name="flask" size={18} color="var(--lb-purple)" />
                            </div>
                            <div style={{ flex:1 }}>
                              <div style={{ fontWeight:700, fontSize:14, color:'var(--lb-text-1)' }}>{testName}</div>
                              <div style={{ fontSize:11, color:'var(--lb-text-3)', marginTop:2 }}>Test {i+1} of {labTests.length}</div>
                            </div>
                            {/* Status dropdown */}
                            <select value={status}
                              onChange={e => this.updateStatus(i, e.target.value)}
                              style={{ padding:'5px 10px', borderRadius:8, border:'1.5px solid var(--lb-border)', fontSize:12, fontWeight:600, fontFamily:'inherit', outline:'none', background:'#fff', cursor:'pointer', color: status==='completed'?'#059669': status==='inprogress'?'var(--lb-brand)':'var(--lb-text-2)' }}>
                              <option value="pending">Pending</option>
                              <option value="collected">Collected</option>
                              <option value="inprogress">In Progress</option>
                              <option value="completed">Completed</option>
                            </select>

                            {/* View existing result */}
                            {hasFile && (
                              <button
                                onClick={() => this.viewFile(report.Path)}
                                style={{ marginLeft:8, padding:'5px 12px', borderRadius:8, border:'1.5px solid var(--lb-purple)', background:'var(--lb-purple-light,#F0EDFE)', color:'var(--lb-purple)', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:'inherit', whiteSpace:'nowrap', display:'flex', alignItems:'center', gap:4 }}>
                                <Ico name="eye" size={13} color="var(--lb-purple)" /> View
                              </button>
                            )}
                          </div>

                          {/* File upload area */}
                          <div style={{ padding:'14px 16px' }}>
                            <input ref={this.testFileRefs[i]} type="file"
                              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                              style={{ display:'none' }}
                              onChange={e => this.handleTestFile(i, e.target.files[0])} />

                            {/* If existing file in DB → show it, disable upload */}
                            {hasFile && !file ? (
                              <div style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 14px', borderRadius:10, background:'#F0F9FF', border:'1.5px solid #a5d8ff' }}>
                                <span style={{ fontSize:20 }}>📋</span>
                                <div style={{ flex:1, minWidth:0 }}>
                                  <div style={{ fontWeight:600, fontSize:13, color:'#1e40af' }}>Result file already uploaded</div>
                                  <div style={{ fontSize:11, color:'#6b7280' }}>Click "View" to open the existing file</div>
                                </div>
                                
                              </div>
                            ) : file ? (
                              /* New file selected */
                              <div style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 14px', borderRadius:10, background:'#F0FDF4', border:'1.5px solid #a7f3d0' }}>
                                <span style={{ fontSize:20 }}>📄</span>
                                <div style={{ flex:1, minWidth:0 }}>
                                  <div style={{ fontWeight:600, fontSize:13, color:'#065f46', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{file.name}</div>
                                  <div style={{ fontSize:11, color:'#6b7280' }}>{(file.size/1024).toFixed(1)} KB</div>
                                </div>
                                <button onClick={() => { this.testFileRefs[i].current.value=''; this.setState(s=>({ testFiles:{...s.testFiles,[i]:undefined} })); }}
                                  style={{ border:'none', background:'transparent', cursor:'pointer', color:'#FF6B35', fontSize:18, padding:0, lineHeight:1 }}>✕</button>
                              </div>
                            ) : (
                              /* Upload prompt — no existing file */
                              <button
                                onClick={() => this.testFileRefs[i].current.click()}
                                style={{ width:'100%', padding:'12px 16px', borderRadius:10, border:'2px dashed var(--lb-border)', background:'#FAFAFA', cursor:'pointer', display:'flex', alignItems:'center', gap:10, fontSize:13, color:'var(--lb-text-3)', fontFamily:'inherit', transition:'all .2s' }}
                                onMouseEnter={e=>{ e.currentTarget.style.borderColor='var(--lb-purple)'; e.currentTarget.style.color='var(--lb-purple)'; }}
                                onMouseLeave={e=>{ e.currentTarget.style.borderColor='var(--lb-border)'; e.currentTarget.style.color='var(--lb-text-3)'; }}>
                                <span style={{ fontSize:20 }}>📎</span>
                                <div style={{ textAlign:'left' }}>
                                  <div style={{ fontWeight:600 }}>Upload Result File</div>
                                  <div style={{ fontSize:11 }}>PDF, Image, or Document</div>
                                </div>
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    <div style={{ textAlign:'right', marginTop:8 }}>
                      <button className="lb-btn-save" onClick={() => this.saveResults()} disabled={saving}>
                        {saving
                          ? <><Ico name="spinner" size={16} color="#fff" className="lb-spinner" /> Saving…</>
                          : <><Ico name="save" size={16} color="#fff" /> Save &amp; Update Results</>}
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   TEST QUEUE PAGE
════════════════════════════════════════════════════════════ */
class QueuePage extends Component {
  render() {
    const pending    = QUEUE_DATA.filter(t=>t.status==='pending').length;
    const inprogress = QUEUE_DATA.filter(t=>t.status==='inprogress').length;
    const urgent     = QUEUE_DATA.filter(t=>t.priority==='urgent').length;
    return (
      <div>
        <div className="lb-page-header lb-fade-up">
          <h1 className="lb-page-title">Test Queue</h1>
          <p className="lb-page-sub">All pending and in-progress tests for today</p>
        </div>
        <div className="lb-stats lb-fade-up">
          {[
            { label:'Total',    value:QUEUE_DATA.length, icon:'flask', color:'var(--lb-purple)', bg:'var(--lb-purple-light)' },
            { label:'Pending',  value:pending,            icon:'bell',  color:'var(--lb-text-3)', bg:'#F1F5F9'                },
            { label:'Urgent',   value:urgent,             icon:'alert', color:'var(--lb-warn)',   bg:'var(--lb-warn-light)'   },
          ].map((s,i) => (
            <div key={i} className={`lb-stat-card lb-fade-up-${i}`}>
              <div className="lb-stat-icon" style={{ background:s.bg }}>
                <Ico name={s.icon} size={20} color={s.color} />
              </div>
              <div>
                <div className="lb-stat-label">{s.label}</div>
                <div className="lb-stat-value">{s.value}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="lb-card lb-fade-up-1">
          <div style={{ overflowX:'auto' }}>
            <table className="lb-table">
              <thead>
                <tr>
                  <th>Appt ID</th><th>Patient</th><th>Test</th>
                  <th>Dept</th><th>Time</th><th>Priority</th><th>Status</th>
                </tr>
              </thead>
              <tbody>
                {QUEUE_DATA.map(row => (
                  <tr key={row.id}>
                    <td><span style={{ fontFamily:'monospace', fontWeight:700, color:'var(--lb-brand)', fontSize:12 }}>{row.id}</span></td>
                    <td><div style={{ fontWeight:600 }}>{row.patient}</div><div style={{ fontSize:11, color:'var(--lb-text-3)' }}>{row.age} yrs</div></td>
                    <td style={{ fontWeight:500 }}>{row.test}</td>
                    <td style={{ color:'var(--lb-text-2)' }}>{row.dept}</td>
                    <td style={{ color:'var(--lb-text-2)' }}>{row.time}</td>
                    <td><LBadge priority={row.priority} /></td>
                    <td><LBadge status={row.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   COMPLETED PAGE
════════════════════════════════════════════════════════════ */
class CompletedPage extends Component {
  render() {
    return (
      <div>
        <div className="lb-page-header lb-fade-up">
          <h1 className="lb-page-title">Completed Tests</h1>
          <p className="lb-page-sub">{COMPLETED_DATA.length} reports ready today</p>
        </div>
        <div className="lb-card lb-fade-up-1">
          <div style={{ overflowX:'auto' }}>
            <table className="lb-table">
              <thead>
                <tr>
                  <th>Appt ID</th><th>Patient</th><th>Test</th>
                  <th>Department</th><th>Date</th><th>Status</th><th>Report</th>
                </tr>
              </thead>
              <tbody>
                {COMPLETED_DATA.map(row => (
                  <tr key={row.id}>
                    <td><span style={{ fontFamily:'monospace', fontWeight:700, color:'var(--lb-brand)', fontSize:12 }}>{row.id}</span></td>
                    <td><div style={{ fontWeight:600 }}>{row.patient}</div><div style={{ fontSize:11, color:'var(--lb-text-3)' }}>{row.age} yrs</div></td>
                    <td style={{ fontWeight:500 }}>{row.test}</td>
                    <td style={{ color:'var(--lb-text-2)' }}>{row.dept}</td>
                    <td style={{ color:'var(--lb-text-2)' }}>{row.date}</td>
                    <td><LBadge status={row.status} /></td>
                    <td><button className="lb-btn-ghost"><Ico name="eye" size={13} /> View</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   BOTTOM NAV
════════════════════════════════════════════════════════════ */
class BottomNav extends Component {
  render() {
    const { activePage, onNav } = this.props;
    const ITEMS = [
      { id:'scan',      label:'Scan',  icon:'qr'    },
      { id:'queue',     label:'Queue', icon:'bell'  },
      { id:'completed', label:'Done',  icon:'check' },
    ];
    return (
      <nav className="lb-bottom-nav">
        {ITEMS.map(item => (
          <button key={item.id}
            className={`lb-bottom-btn${activePage===item.id?' active':''}`}
            onClick={() => onNav(item.id)}>
            <Ico name={item.icon} size={20} color={activePage===item.id?'var(--lb-brand)':'var(--lb-text-3)'} />
            {item.label}
          </button>
        ))}
      </nav>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   LAB DASHBOARD ROOT
════════════════════════════════════════════════════════════ */
const PAGE_META = {
  'scan':      { title:'Lab — Scan QR', subtitle:'Retrieve test orders'   },
  'queue':     { title:'Test Queue',    subtitle:'All pending tests today' },
  'completed': { title:'Completed',     subtitle:'Reports ready today'     },
};

export class LabDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { activePage:'scan', sidebarOpen:false };
  }
  setPage(page)   { this.setState({ activePage:page, sidebarOpen:false }); }
  toggleSidebar() { this.setState(s => ({ sidebarOpen:!s.sidebarOpen })); }

  renderPage() {
    switch (this.state.activePage) {
      case 'scan':      return <ScanPage />;
      case 'queue':     return <QueuePage />;
      case 'completed': return <CompletedPage />;
      default:          return <ScanPage />;
    }
  }

  render() {
    const { activePage, sidebarOpen } = this.state;
    const { onLogout } = this.props;
    const meta = PAGE_META[activePage];
    return (
      <div className="lb-shell">
        <Sidebar activePage={activePage} onNav={p=>this.setPage(p)}
          isOpen={sidebarOpen} onClose={()=>this.setState({sidebarOpen:false})}
          onLogout={onLogout} />
        <div className="lb-main">
          <Header title={meta.title} subtitle={meta.subtitle} onMenuClick={()=>this.toggleSidebar()} />
          <main className="lb-content">{this.renderPage()}</main>
        </div>
        <BottomNav activePage={activePage} onNav={p=>this.setPage(p)} />
      </div>
    );
  }
}

export default LabDashboard;